<template>
    <div class="loading">
      <div class="mask"></div>
        <div class="loading_con">
          <div style="padding-top:10px;padding-bottom:10px;color: #409eff;font-weight: bold;">{{title}}</div>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
        </div>
    </div>
</template>

<script type='text/ecmascript-6'>
    export default {
        name:"Loading",
        data () {
            return {
                
            };
        },
        props:{
           title:""
         }
    }

</script>
<style lang='less' scoped>
.loading{
    @keyframes loading{
        0%{
            transform:scaleY(1);
        }
        50%{
            transform:scaleY(.4);
        }
        100%{
            transform:scaleY(1);
        }
    }
    @-webkit-keyframes loading{
        0%{
            -webkit-transform:scaleY(1);
        }
        50%{
            -webkit-transform:scaleY(.4);
        }
        100%{
            -webkit-transform:scaleY(1);
        }
    }
    @-moz-keyframes loading{
        0%{
            -moz-transform:scaleY(1);
        }
        50%{
            -moz-transform:scaleY(.4);
        }
        100%{
            -moz-transform:scaleY(1);
        }
    }
    @-ms-keyframes loading{
        0%{
            -ms-transform:scaleY(1);
        }
        50%{
            -ms-transform:scaleY(.4);
        }
        100%{
            -ms-transform:scaleY(1);
        }
    }
    @-o-keyframes loading{
        0%{
            -o-transform:scaleY(1);
        }
        50%{
            -o-transform:scaleY(.4);
        }
        100%{
            -o-transform:scaleY(1);
        }
    }
    .loading_con{
        position: fixed;
        z-index:501;
        top:50%;
        left:50%;
        margin:-45px 0 0 -61px;
        /*padding-top:16px;*/
        padding-bottom:20px;
        width:121px;
        height:63px;
        /*background: #f6f6f6;*/
        text-align: center;
        border-radius: 8px;
        i{
            display:inline-block;
            width:4px;
            height:35px;
            border-radius:2px; 
            background:#fff;
            /*background:#333;*/
            opacity:0.8;
            margin:0 2px;
            &:nth-child(1){
                animation:loading 0.6s ease-in -0.4s infinite;
                -webkit-animation:loading 0.6s ease-in -0.4s infinite;
                -moz-animation: loading 0.6s ease-in -0.4s infinite;
                -ms-animation: loading 0.6s ease-in -0.4s infinite;
                -o-animation: loading 0.6s ease-in -0.4s infinite;
            }
            &:nth-child(2){
                animation:loading 0.6s ease-in -0.3s infinite;
                -webkit-animation:loading 0.6s ease-in -0.3s infinite;
                -moz-animation: loading 0.6s ease-in -0.3s infinite;
                -ms-animation: loading 0.6s ease-in -0.3s infinite;
                -o-animation: loading 0.6s ease-in -0.3s infinite;
            }
            &:nth-child(3){
                animation:loading 0.6s ease-in -0.2s infinite;
                -webkit-animation:loading 0.6s ease-in -0.2s infinite;
                -moz-animation: loading 0.6s ease-in -0.2s infinite;
                -ms-animation: loading 0.6s ease-in -0.2s infinite;
                -o-animation: loading 0.6s ease-in -0.2s infinite;
            }
            &:nth-child(4){
                animation:loading 0.6s ease-in -0.1s infinite;
                -webkit-animation:loading 0.6s ease-in -0.1s infinite;
                -moz-animation: loading 0.6s ease-in -0.1s infinite;
                -ms-animation: loading 0.6s ease-in -0.1s infinite;
                -o-animation: loading 0.6s ease-in -0.1s infinite;
            }
            &:nth-child(5){
                animation:loading 0.6s ease-in infinite;
                -webkit-animation:loading 0.6s ease-in infinite;
                -moz-animation: loading 0.6s ease-in infinite;
                -ms-animation: loading 0.6s ease-in infinite;
                -o-animation: loading 0.6s ease-in infinite;
            }
             &:nth-child(6){
                animation:loading 0.6s ease-in infinite;
                -webkit-animation:loading 0.6s ease-in infinite;
                -moz-animation: loading 0.6s ease-in infinite;
                -ms-animation: loading 0.6s ease-in infinite;
                -o-animation: loading 0.6s ease-in infinite;
            }
        }
        
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue